import { render, staticRenderFns } from "./SectionRiskCodesAdditiveForm.vue?vue&type=template&id=58a64ff2&"
import script from "./SectionRiskCodesAdditiveForm.vue?vue&type=script&lang=js&"
export * from "./SectionRiskCodesAdditiveForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports